import { Button, IconButton } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import React, { useState } from "react";

const useStyles = makeStyles(
  () => ({
    borderDiv: {
      alignItems: "center",
      border: "1px solid gray",
      borderRadius: "5px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      width: "160px"
    },
    buttonCancel: {
      width: "130px"
    },
    buttonDecrement: {
      fontSize: 20,
      height: "10px",
      width: "10px"
    },
    buttonGenerate: {
      "&:hover": {
        background: "#0030FF"
      },
      backgroundColor: "#0030FF",
      marginLeft: "10px",
      width: "130px"
    },

    buttonIncrement: {
      fontSize: 20,
      height: "10px",
      width: "10px"
    },

    dialogContent: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center"
    },
    dialogContentNumOfSheets: {
      color: "#000000",
      fontSize: 18,
      marginRight: "10px",
      marginTop: "10px"
    },
    dialogContentText: {
      alignItems: "center",
      color: "#000000",
      display: "flex",
      justifyContent: "center",
      paddingBottom: "20px"
    },
    dialogCount: {
      color: "#000000",
      fontSize: 18,
      paddingTop: "10px"
    },
    dialogTitle: {
      alignItems: "center",
      color: "#000000",
      display: "flex",
      fontSize: 18,
      fontWeight: "bold",
      justifyContent: "center",
      marginLeft: "190px",
      paddingTop: "20px"
    },
    divColumn: {
      alignItems: "center",
      flex: 1,
      flexDirection: "column",
      justifyContent: "center"
    },
    divRow: {
      display: "flex",
      flexDirection: "row"
    },
    xButton: {
      color: "#000000",
      marginLeft: "130px"
      // marginTop: "5px"
    }
  }),
  { name: "GenerateParcelIdDialog" }
);

export interface GenerateParcelIdDialogProps {
  open: boolean;
  handleClose: Function;
  onGenerate(count): void;
}

const GenerateParcelIdDialog: React.FC<GenerateParcelIdDialogProps> = props => {
  const classes = useStyles(props);
  const { open, handleClose, onGenerate } = props;
  const [count, setCount] = useState(0);
  const handleIncrement = () => setCount(count + 1);
  const handleDecrement = () => {
    if (count <= 0) {
      return;
    }
    setCount(count - 1);
  };

  return (
    <Dialog
      open={open}
      //   onClose={() => handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <div className={classes.divColumn}>
        <div className={classes.divRow}>
          {" "}
          <DialogContentText className={classes.dialogTitle}>
            Generate Parcel ID Barcodes
          </DialogContentText>
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            className={classes.xButton}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className={classes.dialogContent}>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.dialogContentNumOfSheets}
          >
            No. of sheets
          </DialogContentText>
          <div className={classes.borderDiv}>
            <Button
              onClick={handleDecrement}
              className={classes.buttonDecrement}
            >
              -
            </Button>
            <DialogContentText className={classes.dialogCount}>
              {count}
            </DialogContentText>
            <Button
              onClick={handleIncrement}
              className={classes.buttonIncrement}
            >
              +
            </Button>
          </div>
        </DialogContent>
        <div className={classes.dialogContentText}>
          <Button
            onClick={() => handleClose()}
            variant="contained"
            color="default"
            className={classes.buttonCancel}
          >
            <span style={{ color: "#002972" }}>Cancel</span>
          </Button>
          <Button
            disabled={count <= 0}
            onClick={() => {
              onGenerate(count);
              handleClose();
              setCount(0);
            }}
            variant="contained"
            className={classes.buttonGenerate}
          >
            <span style={{ color: "#FFFFFF" }}>Generate</span>
          </Button>
        </div>
        <DialogContentText
          id="alert-dialog-description"
          className={classes.dialogContentText}
        >
          Note: 36 barcodes will be printed per page
        </DialogContentText>
      </div>
    </Dialog>
  );
};
GenerateParcelIdDialog.displayName = "GenerateParcelIdDialog";
export default GenerateParcelIdDialog;
